import OrdersCalendar from './orders-calendar.vue'

export default {
  'orders-calendar': OrdersCalendar
}
